<template>
  <div class="report-comment-page">
    <div class="comment-container col-block">
      <div class="comment-field row-block" v-if="rolePermission(['advance', 'admin'])">
        <div class="comment-block col-block" :style="{ flex: 1 }">
          <div class="title-container row-block">
            <div :style="{ 'min-width': '10px' }"></div>
            <div class="title-block row-block ellipsis">
              <div class="time ellipsis">{{ dateFormat(new Date(now), 'yyyy/MM/dd hh:mm') }}</div>
              <div :style="{ 'min-width': '3px' }"></div>
              <div class="user">{{ user.name }}</div>
            </div>
            <div :style="{ flex: 1, 'min-width': '20px' }"></div>
            <div class="alert-block ellipsis">請注意自身發言，勿發表冒犯或不法言論，管理員有權刪除留言。</div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="form-container input-group">
            <textarea rows="4" placeholder="請輸入留言文字。" v-model="comment"></textarea>
          </div>
        </div>
        <div :style="{ width: '10px' }"></div>
        <div class="button-container row-block" :style="{ width: '73px' }">
          <button type="button" name="button" class="main-button option-button" :disabled="!comment" @click="e => sendComment()">
            <span>留言</span>
          </button>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
      <div class="comment-field row-block" v-for="(comment, index) in comments" :key="index">
        <div class="alert-container col-block" v-if="rolePermission(['advance', 'admin']) && comment.id" :class="{ active: currentAlert === comment }">
          <div :style="{ flex: 1 }"></div>
          <template v-if="currentAlert === comment">
            <div class="alert-title row-block">
              <img :src="require('../../assets/images/delete-comment-alert-icon.svg')" alt="">
              <div :style="{ width: '15px' }"></div>
              <div class="alert-text">此動作不可復原，確認是否刪除留言?</div>
            </div>
            <div :style="{ height: '12px' }"></div>
            <div class="button-container row-block">
              <button class="gray-button" @click="e => currentAlert = null">
                <span>取消</span>
              </button>
              <div :style="{ width: '20px' }"></div>
              <button class="error-button" @click="e => deleteComment(comment)">
                <span>刪除</span>
              </button>
            </div>
          </template>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="comment-block col-block" :style="{ flex: 1 }">
          <div class="title-container row-block">
            <div :style="{ width: '10px' }"></div>
            <div class="title-block row-block">
              <div class="time">{{ dateFormat(new Date(comment.created_at), 'yyyy/MM/dd hh:mm') }}</div>
              <div :style="{ width: '3px' }"></div>
              <div class="user">{{ comment.user_name }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="form-container input-group">
            <div class="content">{{ comment.content }}</div>
          </div>
        </div>
        <div :style="{ width: '10px' }"></div>
        <div class="button-container row-block" :style="{ width: '73px' }">
          <button v-if="rolePermission(['advance', 'admin']) && comment.id" type="button" name="button" class="alert-button option-button center-block" @click="e => currentAlert = comment">
            <img :src="require('../../assets/images/button-trash-icon.svg')" alt="">
          </button>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getReportComments, postReportComment, deleteReportComment } from '../../api'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import userPermission from '../../mixins/userPermission'
import { dateFormat } from '../../constants/global/util'

export default {
  mixins: [
    routeLoading,
    toastMethods,
    userPermission
  ],
  props: {
    reportID: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      comments: [],
      now: new Date(),
      comment: '',
      currentAlert: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    // global
    dateFormat () { return dateFormat }
  },
  watch: {
    'reportID' () {
      this.fetchData()
    }
  },
  methods: {
    async fetchData () {
      await this.fetchComments()
    },
    async fetchComments () {
      try {
        let config = this.$ls.get('userInfo')
        let reportID = this.reportID
        let response = await getReportComments(reportID, config)
        let comments = response.data.data
        this.comments = comments.reverse()
      } catch (error) {
        throw error
      }
    },
    async sendComment () {
      try {
        let config = this.$ls.get('userInfo')
        let reportID = this.reportID
        let data = {
          content: this.comment
        }
        await postReportComment(reportID, data, config)
        this.comment = ''
        await this.fetchComments()
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async deleteComment (comment) {
      try {
        let config = this.$ls.get('userInfo')
        let reportID = this.reportID
        let id = comment.id
        await deleteReportComment(id, reportID, config)
        await this.fetchComments()
        this.currentAlert = null
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/comment.vue